/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class ActivityThreeDimensionMap {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			this.url = json['url'];
			this.isDummy = json['is_dummy'];
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getUrl():string {
			return this.url;
		}

		public getIsDummy():boolean {
			return this.isDummy;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private url:string;
		private isDummy:boolean;
	}
}
